import styles from '../Interview.module.scss'
import React from 'react';

type Props = {
  src: string
  srcsp: string
  alt: string
  link: string
}

const ImageLink: React.FC<Props> = ({ src, alt, link, srcsp }) => {

  return (
    <div className={styles.imglink_wrapper}>
      <a href={link} target="_blank" className={styles.imglink} rel="noopener">
        <picture className={styles.imglink_pic}>
          <source srcSet={src} media="(min-width: 719px)" />
          <img src={srcsp} alt={alt} className={styles.imglink_pic_img} />
        </picture>
      </a>
    </div>
  )
}

export default ImageLink